import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${API_BASE}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Auth
export const login = (email, password) => api.post("/auth/login", { email, password });
export const logout = () => api.post("/auth/logout");
export const getMe = () => api.get("/auth/me");

// Site Config (CMS)
export const getSiteConfig = (section) => api.get(`/site-config/${section}`);
export const updateSiteConfig = (section, data) => api.put(`/site-config/${section}`, { data });

// Media
export const uploadMedia = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
};
export const listMedia = () => api.get("/media");
export const deleteMedia = (fileId) => api.delete(`/media/${fileId}`);
export const getMediaUrl = (fileId) => `${API}/media/file/${fileId}`;

// Projects
export const getProjects = (category) => api.get("/projects", { params: category ? { category } : {} });
export const getProject = (id) => api.get(`/projects/${id}`);
export const createProject = (data) => api.post("/projects", data);
export const updateProject = (id, data) => api.put(`/projects/${id}`, data);
export const deleteProject = (id) => api.delete(`/projects/${id}`);

// Team
export const getTeam = () => api.get("/team");
export const getTeamMember = (id) => api.get(`/team/${id}`);
export const createTeamMember = (data) => api.post("/team", data);
export const updateTeamMember = (id, data) => api.put(`/team/${id}`, data);
export const deleteTeamMember = (id) => api.delete(`/team/${id}`);

// Partners
export const getPartners = () => api.get("/partners");
export const createPartner = (data) => api.post("/partners", data);
export const updatePartner = (id, data) => api.put(`/partners/${id}`, data);
export const deletePartner = (id) => api.delete(`/partners/${id}`);

// News
export const getNews = () => api.get("/news");
export const getNewsItem = (id) => api.get(`/news/${id}`);
export const createNews = (data) => api.post("/news", data);
export const updateNews = (id, data) => api.put(`/news/${id}`, data);
export const deleteNews = (id) => api.delete(`/news/${id}`);

// Blog
export const getBlogPosts = () => api.get("/blog");
export const getBlogPost = (id) => api.get(`/blog/${id}`);
export const createBlogPost = (data) => api.post("/blog", data);
export const updateBlogPost = (id, data) => api.put(`/blog/${id}`, data);
export const deleteBlogPost = (id) => api.delete(`/blog/${id}`);

// Contact
export const submitContact = (data) => api.post("/contact", data);
export const getContacts = () => api.get("/contact");
export const deleteContact = (id) => api.delete(`/contact/${id}`);

// Stats
export const getStats = () => api.get("/stats");
export const updateStats = (data) => api.put("/stats", data);

// Publications
export const getPublications = () => api.get("/publications");
export const getPublication = (id) => api.get(`/publications/${id}`);
export const createPublication = (data) => api.post("/publications", data);
export const updatePublication = (id, data) => api.put(`/publications/${id}`, data);
export const deletePublication = (id) => api.delete(`/publications/${id}`);

// Gallery
export const getAlbums = () => api.get("/gallery/albums");
export const createAlbum = (data) => api.post("/gallery/albums", data);
export const updateAlbum = (id, data) => api.put(`/gallery/albums/${id}`, data);
export const deleteAlbum = (id) => api.delete(`/gallery/albums/${id}`);
export const getGalleryItems = (albumId) => api.get("/gallery/items", { params: albumId ? { album_id: albumId } : {} });
export const createGalleryItem = (data) => api.post("/gallery/items", data);
export const deleteGalleryItem = (id) => api.delete(`/gallery/items/${id}`);

// Search
export const searchAll = (q) => api.get("/search", { params: { q } });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
